class ImperiaMobileStickyAtc extends HTMLElement {
  connectedCallback() {
    this.rootSelector = this.dataset.rootSelector;
    this.priceSelector = this.dataset.priceSelector;
    this.button = this.querySelector('[data-sticky-atc-button]');
    this.price = this.querySelector('[data-sticky-atc-price]');
    this.defaultButtonText = 'A' + String.fromCharCode(209) + 'ADIR AL CARRITO';
    this.isMobile = window.matchMedia('(max-width: 749px)');
    this.sourceCtaVisible = true;
    this.update = this.update.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);
    this.root = document.querySelector(this.rootSelector);
    if (!this.root || !this.button) return;
    this.button.addEventListener('click', this.handleClick);
    this.root.addEventListener('change', this.update);
    this.root.addEventListener('input', this.update);
    this.root.addEventListener('variant:change', this.update);
    this.root.addEventListener('variant:changed', this.update);
    this.isMobile.addEventListener('change', this.handleViewportChange);
    this.mutationObserver = new MutationObserver(this.update);
    this.mutationObserver.observe(this.root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'hidden'],
    });
    this.intersectionObserver = new IntersectionObserver(this.handleIntersection, { threshold: 0.01 });
    this.update();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
    this.root?.removeEventListener('change', this.update);
    this.root?.removeEventListener('input', this.update);
    this.root?.removeEventListener('variant:change', this.update);
    this.root?.removeEventListener('variant:changed', this.update);
    this.isMobile?.removeEventListener('change', this.handleViewportChange);
    this.mutationObserver?.disconnect();
    this.intersectionObserver?.disconnect();
    document.body.classList.remove('imperia-sticky-atc-visible');
  }

  handleIntersection = (entries) => {
    const entry = entries[0];
    this.sourceCtaVisible = Boolean(entry?.isIntersecting && entry.intersectionRatio > 0);
    this.updateVisibility();
  };

  handleViewportChange() {
    this.updateVisibility();
  }

  handleClick() {
    if (this.sourceButton && !this.sourceButton.disabled) this.sourceButton.click();
  }

  update() {
    const sourceButton = this.root?.querySelector('[ref="addToCartButton"]');
    const sourcePrice = this.root?.querySelector(this.priceSelector);

    if (sourceButton !== this.sourceButton) {
      this.intersectionObserver?.disconnect();
      this.sourceButton = sourceButton;
      if (this.sourceButton) this.intersectionObserver?.observe(this.sourceButton);
    }

    if (sourcePrice?.textContent?.trim()) this.price.textContent = sourcePrice.textContent.trim();

    if (this.sourceButton) {
      const isDisabled = this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';
      const sourceText = this.sourceButton.querySelector('.add-to-cart-text__content')?.textContent?.trim() || this.sourceButton.textContent.trim();
      this.button.disabled = isDisabled;
      this.button.textContent = isDisabled && sourceText ? sourceText : this.defaultButtonText;
    }

    this.updateVisibility();
  }

  updateVisibility() {
    const shouldShow = Boolean(this.root && this.sourceButton && this.isMobile.matches && !this.sourceCtaVisible);
    this.hidden = !shouldShow;
    document.body.classList.toggle('imperia-sticky-atc-visible', shouldShow);
  }
}

if (!customElements.get('imperia-mobile-sticky-atc')) {
  customElements.define('imperia-mobile-sticky-atc', ImperiaMobileStickyAtc);
}
